import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Whether dealing with a single asset or a large portfolio, our experts can advise clients on all types of hotel property, whether in Madrid, Barcelona, Málaga, Spain regions, or globally.
          </h3>
          <p>

Covering acquisitions, valuations and transactions, financings and M&A, our specialists have a strong track record in every part of the sector, always tailoring their advice to each client, whether an individual, investor, or owner operator.
This includes not just hotel companies, hotel real estate, but also serviced apartments, hostels, resorts and institutional premises. Our integrated global network ( Torus Network )                        of over 700 partners are well-placed throughout Asia-Pacific, the UK, Europe and the US and China, giving us unique positioning to access competitive sources of capital.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionDestacadas featured= {featured} url="hotel" />
          <SectionRecents recents= {recents} url="hotel" />
        </GridItem>
        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
